// A Job Schedule is scheduled_date + start_time for duration_minutes of clock time, and a multi-day job
// (JOB-FR-01-003) runs over several days: the crew is booked for the whole days in between and one
// working day on the last one. The backend overlap check reads it the same way.
export const WORKDAY_MINUTES = 8 * 60;
const DAY_MINUTES = 24 * 60;

/** duration_minutes for an N-day job: whole days, the last one a working day. */
export const durationForDays = (days: number) => (Math.max(1, days) - 1) * DAY_MINUTES + WORKDAY_MINUTES;

/** How many calendar days a booked window touches (1 when there is no duration). */
export const daysSpanned = (startTime: string | null | undefined, minutes: number | null | undefined) => {
  if (!minutes) return 1;
  const [h, m] = (startTime || '00:00').split(':').map(Number);
  return Math.floor(((h || 0) * 60 + (m || 0) + minutes - 1) / DAY_MINUTES) + 1;
};
